module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 19\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#9ECAFF\" transform=\"translate(1 1)\"><path d=\"M.5 4l10.46 6.37a2 2 0 0 0 2.08 0l9.34-5.69L23.5 4\"/><rect width=\"24\" height=\"17\" rx=\"2\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/mail.svg
// module id = G10h
// module chunks = 5